import { useEffect } from 'react';
import { FormSpy } from 'react-final-form';

/**
 * FairwayBid – meldet die gewählte Seite aus dem Registrierungsformular
 *
 * Auf /signup steht zuerst die Auswahl "Golfanlage oder Händler". Die
 * Argumente daneben sollen in dem Moment umspringen, in dem sie getroffen
 * wird – vorher stand dort eine Fassung für beide, und sie blieb es auch
 * dann noch, wenn die Frage längst beantwortet war.
 *
 * Der Wert liegt im Formular, die Fläche steht daneben – also muss er nach
 * oben gereicht werden. FormSpy horcht auf die Formularwerte, ohne dass das
 * Formular selbst etwas davon wissen muss.
 *
 * Warum der Umweg über einen zweiten Baustein mit useEffect: FormSpy ruft
 * seine Rückmeldung während der Formularänderung auf. Von dort direkt den
 * Zustand der Seite zu setzen hieße, während des Renderns eines Bausteins
 * einen anderen zu ändern – React beschwert sich darüber zu Recht. Der
 * Effekt läuft danach, und damit ist die Reihenfolge sauber.
 */

const Melder = ({ wert, onChange }) => {
  useEffect(() => {
    if (onChange) onChange(wert || null);
  }, [wert, onChange]);
  return null;
};

const TypBeobachter = ({ onChange }) => (
  <FormSpy subscription={{ values: true }}>
    {({ values }) => <Melder wert={values?.userType} onChange={onChange} />}
  </FormSpy>
);

export default TypBeobachter;
